import { DATALAKE_PROMPTS_PATH } from "src/utils/api-routes"
import { ServiceRequest } from "src/utils/service-request"

class PromptService {

    constructor() {
        this.serviceRequest = new ServiceRequest()
    }

    async getPrompts() {
        const path = `${DATALAKE_PROMPTS_PATH}?limit=1000&offset=0`
        return await this.serviceRequest.get(path)
    }

    async getPrompt(promptId) {
        return await this.serviceRequest.get(`${DATALAKE_PROMPTS_PATH}/${promptId}`)
    }

    async getPromptByTipoDocumento(tipoDocumento) {
        const path = `${DATALAKE_PROMPTS_PATH}?tipo_documento=${encodeURIComponent(tipoDocumento)}`
        return await this.serviceRequest.get(path)
    }

    async createPrompt(tipoDocumento, prompt) {
        const body = {
            TipoDocumento: tipoDocumento,
            Prompt: prompt,
        }
        return await this.serviceRequest.post(DATALAKE_PROMPTS_PATH, body)
    }

    async updatePrompt(promptId, TipoDocumento, Prompt) {
        const body = {
            TipoDocumento: TipoDocumento,
            Prompt: Prompt,
        }
        return await this.serviceRequest.patch(`${DATALAKE_PROMPTS_PATH}/${promptId}`, body)
    }

    async deletePrompt(promptId) {
        const path = `${DATALAKE_PROMPTS_PATH}/${promptId}`
        return await this.serviceRequest.delete(path)
    }
}
export default PromptService